
// Available environments

const Environments = {
    Local: 'Local',
    Production: 'Production'
};

// The main configuration object with properties

const Configuration = {
    Local: {
        ApplicationHost: 'https://localhost:44321',
        PurchaseOptionsEndpoint: 'https://localhost:44321/api/plan/GetPurchaseOptions',
        CreateVideoEndpoint: 'https://localhost:44321/create',
        VideosListEndpoint: 'https://localhost:44321/videos',
        PlansEndpoint: 'https://localhost:44321/plans/p'
    },
    Production: {
        ApplicationHost: 'https://app.specterr.com',
        PurchaseOptionsEndpoint: 'https://app.specterr.com/api/plan/GetPurchaseOptions',
        CreateVideoEndpoint: 'https://app.specterr.com/create',
        VideosListEndpoint: 'https://app.specterr.com/videos',
        PlansEndpoint: 'https://app.specterr.com/plans/p'
    }
};

// Single function to get the configuration property

export function getConfigurationProperty(key) {
    if (typeof window !== 'undefined') {
        const env = (window.location.host === 'specterr.com') 
            ? Environments.Production 
            : Environments.Local;

        return Configuration[env][key];
    }
};